import { motion } from "framer-motion";
import { ArrowRight, Star, MapPin } from "lucide-react";
import { scrollToId } from "@/lib/site";

const LANES = [
  { from: "Houston", to: "Dallas–Fort Worth", time: "~4 hrs", hot: true },
  { from: "Houston", to: "San Antonio", time: "~3 hrs", hot: true },
  { from: "Houston", to: "Austin", time: "~2.5 hrs", hot: true },
  { from: "Houston", to: "New Orleans, LA", time: "~5.5 hrs" },
  { from: "Houston", to: "Oklahoma City, OK", time: "~7 hrs" },
  { from: "Houston", to: "El Paso", time: "~11 hrs" },
];

export default function LaneBoard() {
  return (
    <section id="lanes" data-testid="lane-board" className="border-t border-white/10 bg-surface">
      <div className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end"
        >
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-brand">Reefer Lanes We Run</span>
            <h2 className="mt-4 font-display text-4xl font-black uppercase leading-none tracking-tighter md:text-6xl">
              Know your lane
              <br />
              before you call
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-[#a1a1a8]">
            Out of Houston, these are the temperature-controlled lanes we cover most. Don't see yours?
            We run nationwide OTR on request.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2">
          {LANES.map((lane, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`lane-${i}`}
              className="group flex items-center justify-between gap-4 bg-ink p-6 transition-colors hover:bg-surfaceHover md:p-8"
            >
              <div className="flex items-center gap-4">
                <MapPin className="h-5 w-5 flex-shrink-0 text-brand" />
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 font-display text-lg font-bold uppercase tracking-tight md:text-xl">
                  <span>{lane.from}</span>
                  <ArrowRight className="h-4 w-4 text-brand transition-transform group-hover:translate-x-1" />
                  <span>{lane.to}</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {lane.hot && (
                  <span className="hidden items-center gap-1 text-xs uppercase tracking-widest text-brand sm:flex">
                    <Star className="h-3 w-3 fill-brand" /> Frequent
                  </span>
                )}
                <span className="text-sm text-[#a1a1a8]">{lane.time}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-3 flex flex-col items-start justify-between gap-4 border border-white/10 bg-ink p-6 sm:flex-row sm:items-center md:p-8">
          <span className="text-base text-[#d4d4d8]">
            Different lane or a dedicated reefer run? We'll quote it.
          </span>
          <button
            onClick={() => scrollToId("#contact")}
            data-testid="lane-quote-btn"
            className="group flex items-center gap-2 bg-brand px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-ink transition-colors hover:bg-white"
          >
            Get a Quote
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
